module.exports = __webpack_public_path__ + "static/media/top_infographic.13b5c371.webp";